
































import { Component, Vue, Prop } from 'vue-property-decorator'
import TopMenu from './Components/TopMenu.vue'
import TableMenu from './Components/TableMenu.vue'
import Pagination from '@/app/ui/components/Pagination/index'
import { AdditionalModule } from '@/app/store/modules/additionalinfo'
import { GalleryImageModule } from '@/app/store/modules/galleryImage'
@Component({
  name: 'AdditionalInfo',
  components: {
    'top-menu': TopMenu,
    'table-menu': TableMenu,
    pagination: Pagination,
  },
})
export default class extends Vue {
  // Property Global
  private selected = []
  public get page() {
    return AdditionalModule.Pages
  }
  public get limit() {
    return AdditionalModule.Limit
  }
  public get isLoading() {
    return AdditionalModule.isLoading
  }
  public created() {
    AdditionalModule.paginationParam.search = ''
    this.getData()
    this.getImage()
  }
  public getData() {
    AdditionalModule.getAdditonalData()
  }
  public getImage() {
    GalleryImageModule.getGalleryImageData()
  }

  // Property Top Menu
  private searchInput = ''
  private funcSearch(item) {
    AdditionalModule.paginationParam.search = item
    this.getData()
  }
  public get imageDataCategory() {
    return GalleryImageModule.galleryImageData
  }

  // Property Table
  public get additionalData() {
    return AdditionalModule.additionalData
  }
  public get fields() {
    return AdditionalModule.fields
  }
  private onRowSelected(items) {
    this.selected = items
  }

  // Property Pagination
  private onPageNumChanged(limit: any) {
    AdditionalModule.paginationParam.paging.limit = limit
    this.getData()
  }
  private funcFirstPage() {
    AdditionalModule.paginationParam.paging.page = 1
    this.getData()
  }

  private funcPrevPage() {
    AdditionalModule.paginationParam.paging.page =
      AdditionalModule.paginationParam.paging.page - 1
    this.getData()
  }
  private funcNextPage() {
    AdditionalModule.paginationParam.paging.page =
      AdditionalModule.paginationParam.paging.page + 1
    this.getData()
  }

  private funcLastPage() {
    AdditionalModule.paginationParam.paging.page =
      (this.additionalData.pagination &&
        this.additionalData.pagination.pageCount) ||
      0
    this.getData()
  }

  public clearTableStatus: boolean = false
  public clearRowSelected() {
    this.selected = []
    if (this.clearTableStatus === false) {
      this.clearTableStatus = true
    } else {
      this.clearTableStatus = false
    }
  }
}
